import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import HeartIcon from '@dustin-web/microsite-components/src/icon/generated/heart'
import HeartSolidIcon from '@dustin-web/microsite-components/src/icon/generated/heart-solid'
import { MutableRefObject } from 'react'

type FavoritesBtnType = {
  itemExist: boolean
  popoverOpen: boolean
  setPopoverOpen: (arg0: boolean) => void
  buttonRef?: MutableRefObject<HTMLButtonElement | null>
  withBorder?: boolean
  noText?: boolean
}

export const FavoritesIconButton = ({
  itemExist,
  popoverOpen,
  setPopoverOpen,
  buttonRef,
  withBorder,
  noText,
}: FavoritesBtnType) => {
  const { translate } = useTranslations()

  if (withBorder) {
    return (
      <button
        {...(buttonRef ? { ref: buttonRef } : {})}
        type="button"
        className="u-w-100" // c-product-add-favorites
        aria-label={translate('Favorites_AddToFavorites')}
        data-test-id="favorite-button"
        onClick={() => {
          setPopoverOpen(!popoverOpen)
        }}>
        {itemExist ? (
          <HeartSolidIcon className="u-mr-8 i-20" />
        ) : (
          <HeartIcon className="u-mr-8 i-20" />
        )}
        <span>{translate('Favorite')}</span>
      </button>
    )
  }

  return (
    <button
      {...(buttonRef ? { ref: buttonRef } : {})}
      type="button"
      className="c-add-to-favorites__btn" // c-product-add-favorites
      aria-label={translate('Favorites_AddToFavorites')}
      data-test-id="favorite-button"
      onClick={() => {
        setPopoverOpen(!popoverOpen)
      }}>
      {itemExist ? (
        <HeartSolidIcon className="c-add-to-favorites__icon" />
      ) : (
        <HeartIcon className="c-add-to-favorites__icon" />
      )}
      {noText ? null : <span className="c-add-to-favorites__text">{translate('Favorite')}</span>}
    </button>
  )
}
